<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Api Base Url</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon small @click="fn_checkValidations">save</v-btn>

		</v-toolbar>

		<v-form class="form-element hasToolbar grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field v-model="Form.apibaseurl" label="Name" placeholder=" " v-validate="'required'" :error-messages="errors.collect('api')" data-vv-name="api" required></v-text-field>
	            </v-flex>
				
			</v-layout>
		</v-form>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				Form:{"apibaseurl":null},
			}
		},
		methods:{

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			           this.fn_saveLocal();
			        }
			    });
			},

			fn_saveLocal: function(){
				var self = this;
				this.postData('Lists', this.Form, 
					{
						onSuccess: function(response){
				          console.log(response);
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
	}

</script>


// WEBPACK FOOTER //
// src/components/settings/apibaseurl.vue